<template>
    <div>
        <div class="subscription" v-show="!onCompleted">
            <div class="body-sidebar">
                <form-wizard color="rgba(var(--vs-primary), 1)"  :title="null" :subtitle="null" :finishButtonText="customer.company ? 'Salvar' : 'Salvar e fazer venda'" back-button-text="Retornar" next-button-text="Prosseguir" @on-complete="createOrSave" :startIndex="company.company ? 2 : 0">
                    <tab-content title="Dados Sistema" icon="feather icon-server" :before-change="validateSystemInformationForm">
                        <div class="mb-5 flex justify-center w-full p-2">
                            <system class="p-2 mb-2 min-w-full" :system="company.system" ref="system" @loading="loading"></system>
                        </div>
                    </tab-content>
                    <tab-content title="Dados Proprietário" icon="feather icon-user" :before-change="validateOwnerForm">
                        <div class="mb-5 flex justify-center w-full p-2">
                            <owner class="p-2 mb-2 min-w-full" :owner="company.owner" ref="owner" @loading="loading" :isEditingCompany="isEditingCompany"></owner>
                        </div>
                    </tab-content>
                    <tab-content class="overflow-auto" title="Dados básicos da empresa" icon="feather icon-home" :before-change="validateCompanyForm">
                        <div class="mb-5 flex justify-center w-full p-2">
                            <company class="p-2 mb-2 min-w-full" :company="company.company" ref="company" @loading="loading" :isEditingCompany="isEditingCompany"></company>
                        </div>
                    </tab-content>
                </form-wizard>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        system: () => import('./SystemInformation'),
        owner: () => import('./Owner'),
        company: () => import('./Company'),
        companyAddress: () => import('./Address')
    },
    props: {
        customer: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data () {
        return {
            onLoad:true,
            loadBarProgress: 0,
            onCompleted: false,
            form: {},
            company: {}
        }
    },

    computed: {
        isEditingCompany() {
            return !!this.customer.company;
        }
    },

    methods: {
        loading (status) {
            this.$emit("loading", status);
        },
        async validateSystemInformationForm () {
            this.company.system = this.$refs.system.getForm();
            return await this.$refs.system.validateForm();
        },
        async validateOwnerForm () {
            this.company.owner = this.$refs.owner.getForm();
            // Se for edição de empresa, o formulário do proprietário não será mais obrigatório
            if (this.isEditingCompany) {
                return true;
            } else {
                return await this.$refs.owner.validateForm();
            }
        },
        async validateCompanyForm () {
            this.company.company = this.$refs.company.getForm();
            return await this.$refs.company.validateForm();
        },

        async getCompanyLocation () {
            // Aguardar testes em servidores de homolog, a chave que esta sendo usado junto à api da google rejeita conexão do localhost
            const google = await this.$gmapApiPromiseLazy();
            const geocoder = new google.maps.Geocoder();
            const address = `${this.company.company.address.street} ${this.company.company.address.number}, ${this.company.company.address.neighborhood}, ${this.company.company.address.city}, BRASIL`;
            return new Promise((resolve, reject) => {
                geocoder.geocode( { 'address': address}, (results, status) => {
                    if (status === google.maps.GeocoderStatus.OK) {
                        this.company.company.address.latitude = results[0].geometry.location.lat();
                        this.company.company.address.longitude = results[0].geometry.location.lng();
                        resolve();
                    } else {
                        reject();
                    }
                });

                setTimeout(resolve, 500);
            });
        },
        async createOrSave()
        {
            await this.getCompanyLocation();
            if (this.isEditingCompany){
                this.editCompaign();
            } else {
                this.createCompaign();
            }

        },
        async createCompaign () {
            this.loading(true);
            try {
                const {data} = await this.$axios.post(`company/create`, this.company);
                this.$vs.notify({
                    text: "Usuário Inserido com sucesso!",
                    color:'success',
                    time: 5000
                });
                this.$emit("created", data.data);
                this.$emit("closeSidebar");
                this.loading(false);
                this.$router.push(`/vendas/compania/${data.data.company.id_company}`);
            } catch (err) {
                this.$vs.notify({
                    text: this.handlerError(err.response.data.errors),
                    color:'danger',
                    time: 5000
                });
                this.loading(false);
            }
        },

        async editCompaign () {
            this.loading(true);
            try {
                const {data} = await this.$axios.put(`company/${this.customer.company.id_company}`, this.company);
                this.$vs.notify({
                    text: "Usuário Atualizado com sucesso!",
                    color:'success',
                    time: 5000
                });
                this.$emit("edited", data.data);
                this.loading(false);
            } catch (err) {
                const messages = this.handlerError(err.response.data.errors);
                this.$vs.notify({
                    text: messages,
                    color:'danger',
                    time: 5000
                });
                this.loading(false);
            }
        },

        handlerError(errors) {
            const fields = {
                "company.fantasy_name": "<b>fantasia da empresa</b>",
                "company.social_name": "<b>razão social</b>",
                "company.document_number": "<b>cpf ou cnpj</b>",
                "company.contact.email": "<b>email da empresa</b>",
                "company.fiscal.fiscal_crt": "<b>fical crt</b>",
                "company.fiscal.iss_retido": "<b>iss retido</b>",
                "company.address.street": "<b>nome da rua</b>",
                "company.address.number": "<b>número</b>",
                "company.address.neighborhood": "<b>bairro</b>",
                "company.address.region": "<b>estado</b>",
                "company.address.city": "<b>cidade</b>",
                "company.address.zip": "<b>cep</b>",
                "system.customer_need": "<b>necessidade do cliente</b>",
                "system.business_type": "<b>segmento da empresa</b>",
                "system.company_size": "<b>tamanho da empresa</b>",
                "system.company_profit": "<b>faturamento da empresa</b>",
                "system.met_us.type": "<b>como nos conheceu</b>"
            };

            let messages = "";
            Object.keys(errors).forEach(err => {
                const errName = err.replace(/\_/g, " ");
                const regex = new RegExp(errName, "g");
                if (fields[err]) {
                    messages += `${errors[err][0].replace(regex, fields[err])} <br />`;
                } else {
                    messages += `${errors[err][0].replace(regex, err)} <br />`;
                }
            });

            return messages;
        }
    },

    created () {
        this.company = Object.keys(this.customer).length > 0 ? JSON.parse(JSON.stringify(this.customer)) : {};
    }
}
</script>

<style>
    .select input{
        height: 48.71px;
    }
</style>
<style scoped>
    .load-bar {
        height: 2px;
        background: #af71af;
    }
    .step-content {
        padding: 10px;
        margin: 5%;
        width: 90%;
        min-height: 300px;
        border: 1px solid gray;
    }
</style>
